module.exports = __webpack_public_path__ + "static/vf_mcardigan_core.770f7b8c.svg";